import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { ChangeEvent, useCallback, useEffect, useMemo, useState } from "react";
import { StageProps } from "../../../redux/Hire/jobRequestApi";
import SortableList from "./SortableList";

type Props = {
  status: Array<StageProps>;
  formikSet: (states: Array<StageProps>) => void;
};

const JobRequestStages = ({ status, formikSet }: Props) => {
  const statusInitialList = useMemo(() => {
    let val = {
      clientEndorsement: true,
      clientInterview_1: true,
    };
    status.forEach((el) => {
      if (el.mandatory) val[el.key] = true;
    });
    return val;
  }, [status]);

  const [selectedStages, setSelectedStages] =
    useState<Record<string, boolean>>(statusInitialList);

  const handleChange = useCallback(
    (val: string) => (e: ChangeEvent<HTMLInputElement>) => {
      setSelectedStages((prev) => {
        const newObj = {
          ...prev,
          [val]: e.target.checked,
        };

        formikSet(status.filter((el) => newObj[el.key]));

        return newObj;
      });
    },
    [formikSet, status],
  );

  useEffect(() => {
    setSelectedStages(statusInitialList);
  }, [statusInitialList]);

  return (
    <Grid container item wrap="nowrap">
      <Grid container direction={"column"} item>
        {status.map((el) => (
          <FormControlLabel
            key={el.key}
            control={
              <Checkbox
                name={el.name}
                checked={selectedStages[el.key] || false}
                onChange={handleChange(el.key)}
              />
            }
            disabled={el.mandatory}
            label={el.name}
          />
        ))}
      </Grid>
      <Grid container item direction={"column"} gap={1}>
        <SortableList
          statusList={status}
          selectedStages={selectedStages}
          formikSet={formikSet}
        />
      </Grid>
    </Grid>
  );
};

export default JobRequestStages;
